import React from 'react';
import { Sparkles } from 'lucide-react';
import AgentLanding from '../agents/shared/AgentLanding';
import { schemaMappingAgentSpec } from './spec';

const SchemaMappingAgentPage: React.FC = () => {
  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-cargo-text flex items-center gap-2">
          <Sparkles className="w-6 h-6 text-cargo-accent" />
          Schema Mapping Agent
        </h1>
        <p className="text-cargo-muted mt-1">
          Map a source schema to a target — per-column matches, transformations, and confidence
        </p>
      </div>
      <AgentLanding spec={schemaMappingAgentSpec} />
    </div>
  );
};

export default SchemaMappingAgentPage;
